// extracted by mini-css-extract-plugin
export default {"boardSelectContainer":"Home_boardSelectContainer__moXYy","boardSelect":"Home_boardSelect__4Vrm6"};